import { Model, PrintArea } from "@/models";

export default class PrintAreaCustomization extends Model {
  static type = "printAreaCustomizations";

  printArea: PrintArea;
  output: any;
  uuid: string;
  outputHistory: any[] = [];
  imageOutput: any;
  complete: boolean;
  colorProfile: string;
  warehouseItemCustomizationId: string;
  deviceRatio = 0;
  deviceCanvasWidth = 0;
  deviceCanvasHeight = 0;
  svg: string;
  scaled = false;

  get completed() {
    return this.output?.objects?.length;
  }

  rollback() {
    if (this.canRollback) {
      const popped = this.outputHistory?.pop();
      if (popped) {
        this.output = popped;
      }
    }
  }

  get name() {
    return this.printArea?.name || "-";
  }

  get deviceParamsCalculated(){
	  return this.deviceCanvasHeight && this.deviceCanvasWidth && this.deviceRatio;
  }

  initDeviceDimensions() {
    const parentWidth =
      document.getElementById("canvas_container")?.offsetWidth || 0;
    const parentHeight =
      document.getElementById("container")?.offsetHeight || 0;
      
    const imageRatio = this.printArea.width / this.printArea.height;
    let temporaryWidth =
      this.printArea.width < parentWidth ? this.printArea.width : parentWidth;
    const ratio = this.printArea.width / temporaryWidth;
    let temporaryHeight = this.printArea.height / ratio;
    if (temporaryHeight > parentHeight) {
      temporaryHeight =
        this.printArea.height < parentHeight
          ? this.printArea.height
          : parentHeight;
      temporaryWidth = temporaryHeight * imageRatio;
    }
    this.deviceRatio = temporaryWidth / this.printArea.width;
    this.deviceCanvasWidth = temporaryWidth;
    this.deviceCanvasHeight = temporaryHeight;
  }

  get lastHistoryItem() {
    return this.outputHistory?.[this.historyLength - 1] || null;
  }

  get canRollback() {
    return this.historyLength > 0;
  }

  get historyLength() {
    return this.outputHistory?.length || 0;
  }

  get isFresh(){
    return !this.output || !this.output.objects?.length;
  }
}
